import React, { useEffect, useState } from "react";
import NavbarVisitor from "../Component/NavbarVisitor";
import Footer from "../Component/Footer";
import { useLocation } from "react-router-dom";
import BadgeShow from "../Component/BadgePayment/BadgeShow";
import PaymentMake from "../Component/BadgePayment/PaymentMake";
import { BASE_URL } from "../Component/Baseurl";
import axios from "axios";

const CheckFormStatus = () => {
  const location = useLocation();
  const [submissionData, setSubmissionData] = useState(location.state?.submissionData);
  const [loading, setLoading] = useState(true);

  const visitorId = localStorage.getItem("visitor_id");

  // Extract values safely
  const id = submissionData?.insertedSubmission?.id || submissionData?.id || "";
  const formId = submissionData?.insertedSubmission?.form_id || submissionData?.form_id || "";
  const submissionType = submissionData?.insertedSubmission?.submission_type || submissionData?.submission_type || "";
  const amount = submissionData?.insertedSubmission?.amount || submissionData?.amount || "";
  const paymentStatus = submissionData?.insertedSubmission?.payment_status || submissionData?.payment_status || "";
  const eventUniqueId = submissionData?.insertedSubmission?.event_unique_id || submissionData?.event_unique_id || "";

  // Function to check payment status
  const [prefix, setPrefix] = useState("");
  const [badgeNo, setBadgeNo] = useState("");
  
  const checkPaymentStatus = async () => {
    try {
      console.log("Sending data to check payment status:", { id, formId, visitorId });
  
      const response = await axios.post(`${BASE_URL}checkPaymentStatus`, {
        id,
        formId,
        visitorId,
      });
  
      console.log("Received Response:", response.data);
  
      if (response.data.success) {
        const submissionData = response.data.submissionData;
        
        // Log the prefix and badge_no values
        // console.log("Prefix:", submissionData.prefix);
        // console.log("Badge No:", submissionData.badge_no);

        // Store prefix and badge_no
        setPrefix(submissionData.prefix || "");
        setBadgeNo(submissionData.badge_no || "");

        setSubmissionData((prev) => ({
          ...prev,
          insertedSubmission: { ...prev?.insertedSubmission, ...submissionData },
        }));
      } else {
        console.warn("Payment status check failed:", response.data.message);
      }
    } catch (error) {
      console.error("Error checking payment status:", error);
    } finally {
      setLoading(false);
    }
};

  // Pass prefix and badgeNo to BadgeShow component

  

  // Call API on component load
  useEffect(() => {
    if (id && formId && visitorId) {
      checkPaymentStatus();
    } else {
      setLoading(false);
    }
  }, [id, formId, visitorId]);

  return (
    <>
      <NavbarVisitor />
      <section>
        <div className="container-fluid">
          <div className="row">
            {/* <h3 className="my-3">Form Submission Details:</h3> */}
            {loading ? (
              <div className="text-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              <>
                <div className=""> 
  {/* <div className="invoice-box">
    <div className="invoice-header">
      <div className="invoice-item">
        <strong>ID:</strong> <span>{id}</span>
      </div>
      <div className="invoice-item">
        <strong>Form ID:</strong> <span>{formId}</span>
      </div>
    </div>
    
    <div className="invoice-body">
      <div className="invoice-item">
        <strong>Submission Type:</strong> <span>{submissionType}</span>
      </div>
      <div className="invoice-item">
        <strong>Amount:</strong> <span>₹{amount}</span>
      </div>
      <div className="invoice-item">
        <strong>Payment Status:</strong> 
        <span className={paymentStatus === "paid" ? "paid" : "pending"}>
          {paymentStatus}
        </span>
      </div>
      <div className="invoice-item">
        <strong>Event Unique ID:</strong> <span>{eventUniqueId}</span>
      </div>
    </div>
  </div> */}
</div>


                {/* Conditional Rendering based on submission_type and payment_status */}
                {submissionType === "paid" && paymentStatus === "paid" ? (
                  <BadgeShow prefix={prefix} badgeNo={badgeNo} />
                ) : submissionType === "paid" && paymentStatus !== "paid" ? (
                  <PaymentMake 
                    id={id} 
                    formId={formId} 
                    submissionType={submissionType} 
                    amount={amount} 
                    paymentStatus={paymentStatus} 
                    eventUniqueId={eventUniqueId} 
                  />
                ) : submissionType === "free" ? (
                  <BadgeShow prefix={prefix} badgeNo={badgeNo} />
                ) : null}
              </>
            )}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default CheckFormStatus;
